// client/src/components/CreditPointsModal.jsx
// Modal wrapper around CreditPointsForm — used for the BULK flow (no card to
// host the form inline). The single-student flow embeds CreditPointsForm
// directly in the student card instead, so it never replaces that card.
// onClose(success): true once the action fully applied (parent clears the
// bulk selection); false on cancel.

import Modal from './Modal.jsx';
import CreditPointsForm from './CreditPointsForm.jsx';

export default function CreditPointsModal({ open, onClose, campId, studentIds = [], label }) {
  return (
    <Modal
      open={open}
      onClose={() => onClose(false)}
      title={`עדכון נקודות${label ? ` · ${label}` : ''}`}
      maxWidth="max-w-md"
    >
      <CreditPointsForm
        campId={campId}
        studentIds={studentIds}
        onApplied={() => onClose(true)}
        onCancel={() => onClose(false)}
      />
    </Modal>
  );
}
